import { Grid } from "@mui/material";
import React, { ReactElement } from "react";
import theme from "../../theme";

interface Props {
  children: ReactElement | ReactElement[];
}

const BorderBox: React.FC<Props> = (props) => {
  const { children } = props;
  return (
    <Grid
      container
      sx={{
        border: "1px solid black",
        paddingTop: 2,
        backgroundColor: theme.palette.background.paper,
        px: 2,
      }}
      direction={"row"}
      justifyContent={"space-evenly"}
      alignItems={"center"}
    >
      {children}
    </Grid>
  );
};

export default BorderBox;
